import createMaintenanceService from "./createMaintenanceService";

export default createMaintenanceService("/preferences/organisation");
